import React from 'react' // eslint-disable-line no-unused-vars
import ReactSelect from 'react-select'
import classNames from 'classnames'

class Select extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      active: props.placeholder || (props.field.value && props.field.value.length > 0)
    }

    this.handleBlur = this.handleBlur.bind(this)
  }

  componentWillReceiveProps = nextProps => {
    this.setState({ active: nextProps.placeholder || (nextProps.field.value && nextProps.field.value.length !== 0) })
  }

  handleBlur () {
    this.setState({ active: this.props.field.value && this.props.field.value.length !== 0 })
  }

  _handleFocus (refName, e) {
    this.setState({ active: true }, function () {
      // Opens the menu automatically upon focusing the select field.
      this.refs[refName].setState({ isOpen: true })
    })
  }

  _handleChange (selectedOption, field) {
    var event = {}
    event.preventDefault = () => { }

    event.target = {
      value: selectedOption == null ? '' : selectedOption.value
    }

    // Calling this function before the validate function as validate fn is already refreshing the parent state.
    if (this.props.onChange != null) {
      this.props.onChange(event.target.value, field)
    }

    this.props.validate(event, field)
  }

    handleInputChange = () => {
      this.setState({ active: true })
    }

    render () {
      const { field, disabled, deleteRemoves = true, backspaceRemoves = true, id, labelStyle } = this.props
      const required = ((field.rules.required !== undefined) && (field.rules.required.required === true || field.rules.required.required !== false))
      field.errors = field.errors || []
      const hasErrors = field.errors.length > 0
      const { active } = this.state

      return (

        <div className={classNames('react-floating-label-select', {
          active,
          'form-group': false,
          'has-danger': hasErrors
        })}
        >

          <div className='fli-container'>
            <label
              style={{ whiteSpace: 'nowrap' }}
              htmlFor={field.name}
              className='select-float-label'
            >
              {field.rules.title + (required ? '*' : '')}
            </label>

            <div className={hasErrors ? 'select-control-danger' : ''}>
              <ReactSelect
                style={{ minWidth: `${this.props.minWidth}` }}
                instanceId={id || field.name}
                name={field.name}
                ref={field.name}
                placeholder={this.props.placeholder || ''}
                // autosize={false}
                disabled={disabled}
                options={this.props.options}
                value={field.value}
                searchable={this.props.searchable}
                clearable={this.props.clearable}
                onChange={selectedOption => this._handleChange(selectedOption, field)}
                onBlur={this.handleBlur}
                onFocus={this._handleFocus.bind(this, field.name)}
                onInputChange={this.handleInputChange}
                backspaceRemoves={backspaceRemoves}
                deleteRemoves={deleteRemoves}
              />
            </div>
          </div>

          {field.errors.map((error, i) =>
            <div key={i} className='form-control-feedback'>{error}</div>
          )}

        </div>
      )
    }
}

export default Select



// WEBPACK FOOTER //
// ./src/forms/select-congress.js